<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api.js';
    import UserStore from '../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../components/Header.svelte'; 
    import TopInfo from '../components/TopInfo.svelte';  
    import Preloader from '../components/Preloader.svelte'; 


    let isLoading = false;

    let payments = [];

    const fetchPage = async() => {

        if (!$UserStore || !$UserStore.merchant_id){
            push('/login');
            return;
        } 

        let payment = {}
        let payment_temp = {};

        for(let key in $UserStore.payments) {

            let payment_temp = $UserStore.payments[key];
            payment = {...payment_temp}
            payments.push(payment)
            
        }

        payments = payments;
        
    }


    fetchPage(); 



    async function handleSubmit() {

        isLoading = true;

        let postData = {};

        for(let key in payments) {

          if (!validateFields(payments[key])) {
            alert(`${$_('payments.some_fields_are_invalid')}`)
            isLoading = false;
            return;
          }

        }

        postData.action = 'update_payments';
        postData.token = $UserStore.token
        postData.payments = payments;

        let response = await fetchData(postData);
        if (response.payments) {

            $UserStore.payments = response.payments;
            localStorage.setItem('user',JSON.stringify($UserStore))  
            
            payments = response.payments;;

            alert('הנתונים נשמרו בהצלחה')

        }
        isLoading = false;
    }
    

    function addPayment() {

        let temp = {new:1};
        payments.push(temp);
        payments = payments;

    }

    function validateFields(payment) {
        const isValidCC = payment.cc.length === 16;
        const isValidMonth = payment.month > 0 && payment.month <= 12 && payment.month.length === 2;
        const isValidYear = payment.year.length === 4 && parseInt(payment.year) >= new Date().getFullYear();
        const isValidCVV = payment.cvv.length === 3;

        return isValidCC && isValidMonth && isValidYear && isValidCVV;
    }

    function removePayment(index) {

        if (confirm(`${$_('payments.delete_confirmation')}`)) {

            payments.splice(index, 1);
            payments = payments;
        }
        
    }

    



        
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">    
        <TopInfo/>
        <div class="shipment p-5">            
            <h1 class="text-[20px] font-bold">
                {$_('payments.title')}
            </h1>

            <div class="flex items-center mt-5">
                <div class="cursor-pointer text-center border-custom-border-blue bg-custom-bg-blue text-white px-4 py-2 rounded-[30px] rounded-s-[0px] w-[220px] text-enter" on:click={ ()=> addPayment() }>{$_('payments.add')}</div>
            </div>    
            <div class="shipment-flex">
                <div class="shipment_origin">                           
                    <div class="">
                        {#if !payments.length}
                        <div class="mb-5 mt-5 bg-slate-100 border-slate-200 border-[1px] p-5 rounded-[5px]">                            
                            {$_('payments.not_found')}
                        </div>
                        {/if}
                        <div>
                          {#each payments as payment, index}
                          <div class="mt-5 text-[14px] border-[1px] border-slate-300 rounded-[5px] p-5 bg-slate-50">                                
                            <div class="mb-2 font-bold">
                              {$_('payments.card')} {index + 1}
                            </div>
                            <div class="flex gap-2">
                              {#if payment.new==1}
                              <div class="mb-2">
                                <label for="cc{index}">{$_('payments.credit_card_number')}</label>
                                <input 
                                  dir="ltr" 
                                  class="text-left" 
                                  id="cc{index}" 
                                  type="text" 
                                  maxlength="16" 
                                  pattern="\d*" 
                                  bind:value={payment.cc} 
                                  placeholder="16 digits" 
                                  title="Enter a 16-digit credit card number">
                              </div>
                              <div class="mb-2">
                                <label for="month{index}">{$_('payments.month')}</label>
                                <input 
                                  dir="ltr" 
                                  class="text-left" 
                                  id="month{index}" 
                                  type="text" 
                                  maxlength="2" 
                                  pattern="\d*" 
                                  bind:value={payment.month} 
                                  placeholder="MM" 
                                  title="Enter a valid 2-digit month">
                              </div>
                              <div class="mb-2">
                                <label for="year{index}">{$_('payments.year')}</label>
                                <input 
                                  dir="ltr" 
                                  class="text-left" 
                                  id="year{index}" 
                                  type="text" 
                                  maxlength="4" 
                                  pattern="\d*" 
                                  bind:value={payment.year} 
                                  placeholder="YYYY" 
                                  title="Enter a valid 4-digit year">
                              </div>
                              <div class="mb-2">
                                <label for="cvv{index}">{$_('payments.cvv')}</label>
                                <input 
                                  dir="ltr" 
                                  class="text-left" 
                                  id="cvv{index}" 
                                  type="text" 
                                  maxlength="3" 
                                  pattern="\d*" 
                                  bind:value={payment.cvv} 
                                  placeholder="3 digits" 
                                  title="Enter a 3-digit CVV">
                              </div>
                              {:else}
                              <div class="mb-2">
                                {payment.cc} - {payment.month}/{payment.year}
                              </div>
                              {/if}
                            </div>
                            <div>
                              <div 
                                class="cursor-pointer text-center border-custom-border-blue bg-custom-bg-blue text-white px-4 py-2 rounded-[30px] w-[120px] text-enter" 
                                on:click={() => removePayment(index)}>
                                {$_('payments.delete')}
                              </div>
                            </div>
                          </div>
                        {/each}
                        
                        </div>                        
                    </div>
                </div> 
            </div> 
            {#if payments.length}
            <div class="shipment-flex-button fixed bottom-[20px] z-1 left-0 right-0 m-auto">
                <div class="cursor-pointer box-shadow border-custom-border-blue bg-custom-bg-blue text-white px-4 py-2 rounded-[30px] w-[200px] m-auto text-center" on:click={()=>handleSubmit()}>{$_('payments.save')}</div>
            </div>
            {/if} 

        </div>
        
    </div>
</div>

